import React, { Component, Fragment } from 'react';
import api from '../../services/api';
import Moment from 'react-moment';
import 'moment-timezone';


// Set the timezone for every instance.
// Use local timezone instead of forcing UTC
// Moment.globalTimezone = 'UTC';

class Company extends Component {

    state = {
        load: false,
        companyContacts: {},
        notifications: {}
    }

    async componentDidMount() {
        await this.loadNotifications();
    }

    loadNotifications = async () => {
        const response = await api.get(`/notifications?UserId=${localStorage.getItem('userId')}&order_by=createdAt&order_direction=DESC`);
        this.setState({ notifications: response.data.rows });
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Notificações
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <form action="javascript:void(0)" id="formDocuments">
                    <div className="row alert alert-primary">
                        <span>
                            Notificações dos seus processos no sistema DP World.
                        </span>
                    </div>
                    <div className="row card">
                        <div className="col-md-12 m-t-20">
                            <div className="message-center">
                                {(this.state.notifications.length) ?
                                    (this.state.notifications).map((item) => {
                                        return (
                                            <span key={item.id} href="javascript:void(0)">
                                                <div className="mail-contnet">
                                                    <h5>
                                                        <Moment format="DD/MM/YYYY HH:mm">{item.createdAt}</Moment>
                                                    </h5>
                                                    <span className="text-primary">
                                                        {item.message}
                                                    </span>
                                                </div>
                                                <hr/>
                                            </span>)
                                    })
                                    : null}
                            </div>
                        </div>
                    </div>
                </form>
            </Fragment >
        )
    }

}

export default Company;